import React from 'react';
import ReactDOM from 'react-dom/client';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { Provider } from 'react-redux';
import store from './store';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { applyDocumentBranding } from './config/appConfig';

const readCspNonce = () => {
  if (typeof document === 'undefined') {
    return undefined;
  }

  const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content');

  return nonce || undefined;
};

const emotionCache = createCache({
  key: 'mui',
  nonce: readCspNonce(),
});

const root = ReactDOM.createRoot(document.getElementById('root'));

const queryClient = new QueryClient();

applyDocumentBranding();

root.render(
  <CacheProvider value={emotionCache}>
    <Provider store={store}>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </BrowserRouter>
    </Provider>
  </CacheProvider>,
);

reportWebVitals();
